var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPregnantWoman(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "pregnant_woman_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1997",
    "data-name": "Group 1997"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3328",
    "data-name": "Rectangle 3328",
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2000",
    "data-name": "Group 2000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1999",
    "data-name": "Group 1999"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1998",
    "data-name": "Group 1998"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8333",
    "data-name": "Path 8333",
    d: "M9,4a2,2,0,1,1,2,2A1.993,1.993,0,0,1,9,4Zm7,9a3.285,3.285,0,0,0-2-3,3,3,0,0,0-6,0v7h2v5h3V17h3Z",
    fill: "#f8f9ff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPregnantWoman);
export default __webpack_public_path__ + "static/media/pregnant_woman.f70d817ec9bc07563c615cfe3d145766.svg";
export { ForwardRef as ReactComponent };